import { PresentationTreeNetwork, TaxonomyChild } from 'entities/tag';
import { findAncestorPath, findNodeById } from 'app/utils/tag-utils';

export interface ResolvedConceptNode {
  network: PresentationTreeNetwork;
  node: TaxonomyChild;
  nodePath: string;
  ancestorIds: Set<string>;
}

const resolveInNetwork = (network: PresentationTreeNetwork, conceptId: string): ResolvedConceptNode | null => {
  const root = network.roots[0];
  if (!root) return null;
  const roleURI = network.linkrole.roleURI;
  if (root.id === conceptId) {
    return { network, node: { ...root, order: 0 } as TaxonomyChild, nodePath: `${roleURI}>${root.id}`, ancestorIds: new Set() };
  }
  const path = findAncestorPath(root.children, conceptId);
  const node = path !== null ? findNodeById(root.children, conceptId) : null;
  if (path === null || !node) return null;
  return { network, node, nodePath: [roleURI, root.id, ...path, conceptId].join('>'), ancestorIds: new Set(path) };
};

export function resolveConceptNode(
  networks: PresentationTreeNetwork[],
  conceptId: string,
  preferredRoleURI?: string | null,
  hiddenRoleURIs: Set<string> = new Set(),
  pickedNodePath?: string | null
): ResolvedConceptNode | null {
  const picked = pickedNodePath?.endsWith(`>${conceptId}`) ? pickedNodePath : null;
  const role = picked ? picked.split('>')[0] : preferredRoleURI;
  if (role) {
    const preferred = networks.find((n) => n.linkrole.roleURI === role);
    const resolved = preferred ? resolveInNetwork(preferred, conceptId) : null;
    if (resolved) return picked ? { ...resolved, nodePath: picked } : resolved;
  }
  const isHidden = (network: PresentationTreeNetwork) => hiddenRoleURIs.has(network.linkrole.roleURI);
  for (const network of [...networks.filter((n) => !isHidden(n)), ...networks.filter(isHidden)]) {
    const resolved = resolveInNetwork(network, conceptId);
    if (resolved) return resolved;
  }
  return null;
}
